
import { defineComponent } from 'vue'
import {
  Platte
} from '@icon-park/vue-next'

export default defineComponent({
  name: 'color-button',
  components: {
    Platte
  },
  props: {
    color: {
      type: String,
      required: true,
    },
  },
})
